module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__navigation__page-info"
  }, [_vm._v("\n  " + _vm._s(_vm.pageText) + " "), _c('input', {
    staticClass: "footer__navigation__page-info__current-entry",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.currentPage
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.changePage($event)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.pageInfo) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb1a800"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-good-table/src/components/VgtPaginationPageInfo.vue
// module id = 1005
// module chunks = 1